import styled from "styled-components";

export const Overlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  z-index: 9000;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow-y: auto;
  padding: 24px 16px;
`;

export const Modal = styled.form`
  background: #fff;
  border-radius: 10px;
  width: 100%;
  max-width: 369px;
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  box-shadow: 0 6px 24px rgba(0, 0, 0, 0.18);
`;

export const ModalTitle = styled.h2`
  color: #1b2b3a;
  font-size: 1.3rem;
  font-weight: 700;
  margin: 0;
`;

export const Subtitle = styled.p`
  margin: 0;
  font-size: 0.92rem;
  color: #333;
`;

export const LanguageList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

// El div es el control real: lleva role="radio" para que un lector de pantalla
// lo anuncie como opcion de un grupo, y no como una fila cualquiera.
export const LanguageRow = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 10px 14px;
  border-radius: 8px;
  cursor: pointer;
  background: ${({ $selected }) => ($selected ? "#fff" : "#f5f5f5")};
  border: 1.5px solid ${({ $selected }) => ($selected ? "#1b6b78" : "transparent")};

  &:hover { background: ${({ $selected }) => ($selected ? "#fff" : "#eef1f3")}; }
  &:focus-visible { outline: 2px solid #26A9B6; outline-offset: 2px; }
`;

export const Flag = styled.img`
  width: 38px;
  height: 38px;
  flex-shrink: 0;
`;

export const LanguageName = styled.span`
  flex: 1;
  font-size: 1rem;
  font-weight: 600;
  color: #1b2b3a;
`;

export const Check = styled.span`
  width: 24px;
  height: 24px;
  border-radius: 4px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${({ $selected }) => ($selected ? "#1b6b78" : "#fff")};
  border: 1.5px solid ${({ $selected }) => ($selected ? "#1b6b78" : "#c9d2d9")};

  svg { display: ${({ $selected }) => ($selected ? "block" : "none")}; }
`;

export const ActionRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
`;

export const CancelButton = styled.button`
  padding: 9px 22px;
  border-radius: 6px;
  border: 1.5px solid #26A9B6;
  background: #fff;
  color: #26A9B6;
  font-size: 0.85rem;
  cursor: pointer;

  &:hover { background: #f0fbfc; }
`;

export const SaveButton = styled.button`
  padding: 9px 22px;
  border-radius: 6px;
  border: none;
  background: #1b6b78;
  color: #fff;
  font-size: 0.85rem;
  font-weight: 600;
  cursor: pointer;

  &:hover { background: #175a65; }
`;
